import { Component, Input } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzUploadFile, NzUploadModule } from 'ng-zorro-antd/upload';
import { DynamicFieldModel } from '../dynamic-field-model';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzImageModule } from 'ng-zorro-antd/image';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-dyanmic-form-img',
  imports: [
    NzUploadModule,
    NzIconModule,
    NzFormModule,
    FormsModule,
    NzImageModule,
    CommonModule,
  ReactiveFormsModule ],
  templateUrl: './dyanmic-form-img.component.html',
  styleUrl: './dyanmic-form-img.component.scss'
})
export class DyanmicFormImgComponent {
  @Input() formGroup!: FormGroup;
  @Input() field!: DynamicFieldModel;
  loading:Boolean=false;


  handleChange(info: { file: NzUploadFile }): void {
    const file = info.file;
    this.getBase64(info.file!.originFileObj!, (img: string) => {
      this.loading = false;
      this.formGroup.controls[this.field.name].setValue(img);
    });
  }

  getImageUrl(controlName: string): string | null {
    return this.formGroup.get(this.field.name)?.value || null;
  }

  hasValue(field:DynamicFieldModel):boolean{
    if(field?.readonly){
      return false;
    }
    else if(this.formGroup.get(this.field.name).value){
      return true;
    }
    return false;
  }

  private getBase64(img: File, callback: (img: string) => void): void {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result!.toString()));
    reader.readAsDataURL(img);
  }

  get controlName(): FormControl {
    return this.formGroup.get('controlName') as FormControl;
  }

  getErrorTpl(field: DynamicFieldModel): string {
    const control = this.formGroup.get(field.name);
    if (control && control.errors) {
      for (const validation of field.validations || []) {
        if (control.hasError(validation.name)) {
          return validation.message;
        }
      }
    }
    return '';
  }

  deleteImage(event:any){
    event.stopPropagation();
    event.preventDefault();
    this.formGroup.controls[this.field.name].setValue(null);
  }
}
